export class DeviceParamLirisV3Filter {
    public activated: boolean;
    public channel: number;
    public t0: number;
   // public status: boolean;
}
